import React from "react";

import styles from "../../assets/css/modules/shared/claims-to-bank-navigation.css";
import { Link } from "react-router-dom";
import { Paths } from "../../constants/UrlConstants";
import Store from "../../content/Store";
import { SortCodeFormatter, mask } from "../../helpers/SortCodeFormatter";
import { ButtonConfig } from "../../constants/Constants";



export const ClaimsToBankNavigation = (props) => {


  const MemberBankDetail = !props.MemberBank?.AccountNumber ? props.bank.Add : props.bank.Update;
  const linktobeDisabled = props?.IsInternalView ? styles?.disabled : styles.anchorDecorationUnderline;

  return (
    <div className={styles.InfoBox}>
      <div

        className={styles.SubInfoBox}
      >
        <strong> {MemberBankDetail?.title} </strong>
        <p>{MemberBankDetail?.description}</p>

        {props.MemberBank?.AccountNumber ? (
          <>
            <ul className="list-unstyled membership-meta">


              <li>
                <span className="label">
                  <strong>{Store.ChangeBankDetailsInLine.AccountNoTitle}</strong>
                </span>{" "}
                <span className="axa-mask">
                {props?.IsInternalView ? mask(props.MemberBank?.AccountNumber) : props.MemberBank?.AccountNumber}
                </span>
              </li>
              <li>
                <span className="label">
                  <strong>{Store.ChangeBankDetailsInLine.SortCodeTitle}</strong>
                </span>{" "}
                <span className="axa-mask">{props?.IsInternalView ? mask(props.MemberBank?.SortCode, 2) : SortCodeFormatter(props.MemberBank?.SortCode)}</span>
              </li>
            </ul>
            <p>{MemberBankDetail?.descriptionupdate}</p>
          </>
        ) : null}

      </div>
      <span className={styles.secondaryBlueButton}>
        <button
          id={"edit_bank"}
          onClick={props?.ClaimsClickhandler}
          disabled={props?.IsInternalView ? true : false}
          style={props?.IsInternalView ? { color: "grey", cursor: "not-allowed" } : null}
        >
          <Link
            className={`hol-link  ${linktobeDisabled}`}
            style={props?.IsInternalView ? { color: "grey", cursor: "not-allowed",pointerEvents:"none" } : null}
            
            to={props?.IsInternalView?"#":Paths.ChangeBankDetails}

            onClick={(e) => props?.IsInternalView && e.preventDefault()}
            id={!props.MemberBank?.AccountNumber ? ButtonConfig.ClaimBackAddBankDetails : ButtonConfig.ClaimBackUpdateBankDetails}
          >

            {" "} {MemberBankDetail?.buttonText} <span className="chevron right"></span>
          </Link>

        </button>

      </span>


      {props.children}
    </div>
  );
};

export default ClaimsToBankNavigation;